import { Link, useParams } from "react-router-dom";
import CatalogPage from "../components/equipment/CatalogPage";
import { SHOW_APPLICATION_PAGES } from "../featureFlags";
import { JOBS } from "../data/catalog";
import { ROBOTS } from "../data/robots";
import NotFound from "./NotFound";

export default function ApplicationDetail() {
  const { slug } = useParams();
  const job = JOBS.find((item) => item.slug === slug);

  if (!job) return <NotFound />;

  const matches = ROBOTS.filter((robot) => robot.jobs.includes(job.slug));

  return (
    <CatalogPage
      title={`${job.label} | MAG`}
      description={`Equipment for this job: ${job.label}.`}
      path={`/applications/${job.slug}`}
      noindex={!SHOW_APPLICATION_PAGES}
      h1={job.label}
    >
      <ul className="divide-y divide-gray-200 border border-gray-200">
        {matches.map((robot) => (
          <li key={robot.slug}>
            <Link to={`/catalog/${robot.slug}`} className="block px-5 py-4">
              <p className="font-semibold text-gray-900">{robot.displayName}</p>
              <p className="mt-1 text-sm leading-relaxed text-gray-700">{robot.summary}</p>
            </Link>
          </li>
        ))}
      </ul>
    </CatalogPage>
  );
}
